import type { RouteLocationNormalized } from 'vue-router';

import type { BackState } from '@/composables/useBackState';
import { hasBackStack } from '@/composables/useBackState';

export interface BackButtonRule {
    path: string;
    pageName: string;
}

/**
 * Список страниц, на которых может отображаться кнопка «Назад».
 * pageName соответствует route.name из router.js.
 */
export const BACK_BUTTON_RULES: BackButtonRule[] = [
    { path: '/card/:patientId', pageName: 'patient-card' },
    { path: '/survey/:surveyId', pageName: 'survey-card' },
    { path: '/poll/:pollId', pageName: 'poll-card' },
    { path: '/new-reception/:patientId', pageName: 'new-reception' },
    { path: '/reception/:protocolId?', pageName: 'reception' },
    { path: '/reception/:protocolId?/draft/:draftId', pageName: 'draft' },
    { path: '/good-surveys/:patientGoodIdentificator', pageName: 'goodsurveys' },
    { path: '/notifications', pageName: 'notifications' },
    { path: '/safety', pageName: 'safety' },
];

export const isBackButtonPage = (route: RouteLocationNormalized): boolean => (
    BACK_BUTTON_RULES.some((rule) => rule.pageName === route.name)
);

export const shouldShowBackButton = (
    route: RouteLocationNormalized,
    state: BackState | null,
    stateRevision = 0,
): boolean => {
    if (!hasBackStack(state) || stateRevision < 0) {
        return false;
    }

    return isBackButtonPage(route);
};
